module.exports = __webpack_public_path__ + "static/media/ic-lead-generation.e1141bb2.svg";